const ALLOWED_MOBILE_RETURN_SCHEMES = ["tellescopeapp://auth", "tellescopeapp-staging://auth"];

export const isAllowedMobileReturnScheme = (scheme: string): boolean =>
  ALLOWED_MOBILE_RETURN_SCHEMES.some((allowed) => scheme.startsWith(allowed));
